import React from 'react';
import { TextArea } from '@progress/kendo-react-inputs';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { FormFieldWrapper } from '../FormFieldWrapper';

interface FormTextAreaProps extends FieldRenderProps {
  isLoading?: boolean;
}

export const FormTextArea: React.FC<FormTextAreaProps> = fieldRenderProps => {
  const { isLoading } = fieldRenderProps;

  return (
    <FormFieldWrapper
      validationMessage={fieldRenderProps.validationMessage}
      value={fieldRenderProps.value}
      touched={fieldRenderProps.touched}
      id={fieldRenderProps.id}
      valid={fieldRenderProps.valid}
      disabled={fieldRenderProps.disabled}
      hint={fieldRenderProps.hint}
      label={fieldRenderProps.label}
      wrapperStyle={fieldRenderProps.wrapperStyle}
      optional={fieldRenderProps.optional}
      modified={fieldRenderProps.modified}
      visited={fieldRenderProps.visited}
      onChange={fieldRenderProps.onChange}
      onFocus={fieldRenderProps.onFocus}
      onBlur={fieldRenderProps.onBlur}
      name={fieldRenderProps.name}
      isLoading={isLoading}
    >
      <TextArea
        name={fieldRenderProps.name}
        value={fieldRenderProps.value}
        defaultValue={fieldRenderProps.defaultValue}
        valid={fieldRenderProps.valid}
        onChange={fieldRenderProps.onChange}
        onFocus={fieldRenderProps.onFocus}
        onBlur={fieldRenderProps.onBlur}
        disabled={fieldRenderProps.disabled}
        rows={5}
        validationMessage={fieldRenderProps.validationMessage || undefined}
      />
    </FormFieldWrapper>
  );
};
